import { Box, Typography } from "@mui/material";
import GarudaLogoImage from "../images/garuda-logo.png";
import styles from "./Footer.module.css";
// TODO - need to enable these features - G2XT-2263
// import { Link } from "react-router-dom";

const GarudaLogo = () => {
  const currentYear = new Date().getFullYear();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <img alt="Garuda Logo" src={GarudaLogoImage} />
        <Typography variant="body2" className={styles.copyrightText}>
          Copyright &copy; 2012-{currentYear},{" "}
          <a
            href="https://www.sbx-corp.com/"
            target="_blank"
            rel="noreferrer"
          >
            SBX Corporation.
          </a>
        </Typography>
    </Box>
  );
};

// const SiteLink = styled(Link)(({ theme }) => ({
//   textDecoration: "none",
//   color: "gray",
//   fontSize: 24,
//   textAlign: "left",
//   ":hover": {
//     color: "#333333",
//   },
// }));

// const SiteLinks = () => {
//   return (
//     <Grid container spacing={1} width="100%" style={{ textAlign: "left" }}>
//       <Grid item xs={5}>
//         <SiteLink to="#">Privacy Policy</SiteLink>
//       </Grid>
//       <Grid item xs={3}>
//         <SiteLink to="#">Blog</SiteLink>
//       </Grid>
//       <Grid item xs={3}>
//         <SiteLink to="#">Solutions</SiteLink>
//       </Grid>
//       <Grid item xs={5}>
//         <SiteLink to="#">Terms of Service</SiteLink>
//       </Grid>
//       <Grid item xs={3}>
//         <SiteLink to="#">Legal</SiteLink>
//       </Grid>
//       <Grid item xs={3}>
//         <SiteLink to="#">Partners</SiteLink>
//       </Grid>
//       <Grid item xs={5}>
//         <SiteLink to="#">Pipeline</SiteLink>
//       </Grid>
//       <Grid item xs={3}>
//         <SiteLink to="#">Pipeline</SiteLink>
//       </Grid>
//       <Grid item xs={3}>
//         <SiteLink to="#">Company</SiteLink>
//       </Grid>
//     </Grid>
//   );
// };

export const Footer = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: 40,
        width: "100%",
        margin: "0.5rem 0",
      }}
    >
      <GarudaLogo />
      {/* <SiteLinks /> */}
    </Box>
  );
};
